/* eslint-disable no-param-reassign */
import { createSlice, createAction } from '@reduxjs/toolkit';

import initialState from '../../../domain/app/entities/validarDesafioTcoo';


// ---------------- Saga's response ----------------
function fetchValidarDesafioTcooSuccess(state, action) {
  const { respuestaServicio } = action.payload;
  state.response = respuestaServicio;
  state.errorFetchConfirmar = false;
}

function fetchValidarDesafioTcooError(state) {
  state.response = [];
  state.errorFetchConfirmar = true;
}


const fetchValidarDesafioTcoo = createAction('fetchValidarDesafioTcoo');

// ------------- connection ------------- //

const validarDesafioTcooReducer = createSlice({
  name: 'ValidarDesafioTcoo',
  initialState,
  reducers: {
    fetchValidarDesafioTcooSuccess,
    fetchValidarDesafioTcooError,
  },
});

export const validarDesafioTcooAction = {
  ...validarDesafioTcooReducer.actions,
  fetchValidarDesafioTcoo,
};

export default validarDesafioTcooReducer.reducer;